<ng-template [appRouteDialog]="{ size: 'lg' }" (closed)="skip(true)">
  <sb-dialog-header>
    <div>
      <h2 class="text-2xl font-bold text-default">{{ 'Ready to invite your team?' | translate }}</h2>
      <p class="text-lg text-support">
        {{ 'Great progress! Invite your team now, or feel free to finish up your schedule first.' | translate }}
      </p>
    </div>
  </sb-dialog-header>
  <sb-dialog-content>
    <employees-table [selectable]="true" [form]="form" />
  </sb-dialog-content>
  <sb-dialog-footer>
    <sb-dialog-footer-actions [align]="'end'">
      <button
        sb-button
        [sbLadda]="actionLoading === 'secondary'"
        [disabled]="actionLoading === 'primary'"
        (click)="submit(false)"
      >
        {{ 'Add and invite later' | translate }}
      </button>
      <button
        sb-button
        [color]="'primary'"
        [sbLadda]="actionLoading === 'primary'"
        [disabled]="actionLoading === 'secondary' || selectedRowsCount === 0"
        (click)="submit()"
      >
        {{ 'Add and invite now' | translate }}
      </button>
    </sb-dialog-footer-actions>
  </sb-dialog-footer>
</ng-template>
